import { createContext, useState, useEffect } from 'react';
import { setStore, getStore, removeItem } from '../util'

const UserContext = createContext();

export function UserProvider({ children }) {
    const [user, setUser] = useState(false);

    const setUserStore = (user) =>{
        if (user) {
            setUser(user)
            setStore('user', user)
        } else {
            setUser(undefined)
            removeItem('user')
        }
    }

    useEffect(()=>{
        const _user = getStore('user')
        if (_user) {
            setUser(_user)
        } 
    },[])
    
    return (
        <UserContext.Provider value={{ user, setUserStore }}>
            {children}
        </UserContext.Provider>
    );
}

export default UserContext;
